import { Box } from '@hivebrite/design-system/Box';
import { DatePickerInput } from '@hivebrite/design-system/Inputs';
import { Label } from '@hivebrite/design-system/Label';
import { getDateLabelText } from '@hivebrite/utils';

import dayjs from 'hb-react/shared/utils/dayjs/dayjs';

import type { DateRangeInputProps } from './types';

export const DateRangeInput = ({
  disabled,
  fromInputProps,
  id,
  label,
  sharedInputProps,
  toInputProps,
}: DateRangeInputProps) => (
  <Box flex={1} flexDirection="column" width="100%">
    {label && (
      /* clicking the label will focus the first input */
      /* @ts-expect-error: update ds-label to not require all prop */
      <Label clamp={1} id={`${id}_from`}>
        {getDateLabelText(label)}
      </Label>
    )}
    <Box alignItems="flex-end">
      <Box flex={1} mr={1} width="50%">
        <DatePickerInput
          disabled={disabled}
          {...sharedInputProps}
          id={`${id}_from`}
          name={`${id}_from`}
          {...fromInputProps}
          maxDate={
            toInputProps.value
              ? dayjs(toInputProps.value).format()
              : fromInputProps.maxDate
          }
          placeholder={s__('DateRangeInput|From')}
          locale={I18n.locale}
        />
      </Box>
      <Box flex={1} ml={1} width="50%">
        <DatePickerInput
          disabled={disabled}
          {...sharedInputProps}
          id={`${id}_to`}
          name={`${id}_to`}
          {...toInputProps}
          minDate={
            fromInputProps.value
              ? dayjs(fromInputProps.value).format()
              : toInputProps.minDate
          }
          placeholder={s__('DateRangeInput|To')}
          locale={I18n.locale}
        />
      </Box>
    </Box>
  </Box>
);
